import {IconButton, TableCell, TableRow} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import {useDispatch} from "react-redux";
import {
    FileMeaningsInterface
} from "@/api/ReferenceBooks/Lists/LaboratoryClarifications/FileMeanings/List/Interfaces/FileMeaningsListInterface";
import {
    reset,
    updateFields
} from "@/features/InControlPanel/ReferenceBooks/LaboratoryClarifications/FileMeanings/Slice/FileMeaningsSlice";
import {useTranslation} from "react-i18next";
import {WithPermission} from "@/components/Permissions/WithPermission";

function FileMeaningsListUnit({fileMeanings}: { fileMeanings: FileMeaningsInterface }) {
    const {t} = useTranslation();

    const dispatch = useDispatch();

    const cellOpacity = {opacity: fileMeanings.active ? 1 : 0.6};

    return (
      <TableRow
        hover={!!fileMeanings.active}
        sx={{cursor: fileMeanings.active ? "pointer" : "default"}}
        onClick={handleTableRowClick}
      >
          <TableCell sx={cellOpacity}>{fileMeanings.id}</TableCell>
          <TableCell sx={cellOpacity}>{fileMeanings.title}</TableCell>
          <TableCell sx={cellOpacity}>{fileMeanings.alias}</TableCell>
          <TableCell sx={cellOpacity}>{fileMeanings.active === 1 ? t("Yes") : t("No")}</TableCell>

          <WithPermission permission="file-meanings.edit">
              <TableCell>
                  <IconButton onClick={handleEdit}>
                      <EditIcon color="primary" sx={{cursor: "pointer"}}/>
                  </IconButton>
              </TableCell>
          </WithPermission>

          <WithPermission permission="file-meanings.delete">
              <TableCell>
                  <IconButton onClick={handleDelete}>
                      <DeleteIcon color="error" sx={{cursor: "pointer"}}/>
                  </IconButton>
              </TableCell>
          </WithPermission>
      </TableRow>
    );

    function handleTableRowClick(e: React.MouseEvent) {
        e.stopPropagation();
        if (!fileMeanings.active) {
            return;
        }

        dispatch(updateFields({
            editFileExtensionsModalVisible: true,
            editFileExtensionsId: fileMeanings.id,
        }))
    }

    function handleEdit(e: React.MouseEvent) {
        e.stopPropagation();

        dispatch(reset())
        dispatch(updateFields({
            formVariant: "edit",
            editId: fileMeanings.id,
            editTitle: fileMeanings.title,
            editAlias: fileMeanings.alias,
            editActive: Boolean(fileMeanings.active),
            formVisible: true
        }))
    }

    function handleDelete(e: React.MouseEvent) {
        e.stopPropagation();

        dispatch(reset())
        dispatch(updateFields({
            deleteId: fileMeanings.id,
            deleteStatusModalVisible: true
        }))
    }
}

export default FileMeaningsListUnit;
